/**
 * Reads the Rails CSRF token from the page's <meta name="csrf-token"> tag.
 * Returns an empty string if the meta tag isn't present (e.g. during a Jest
 * test without a full DOM mock). Use this for any fetch() that mutates
 * server state.
 */
export const getCsrfToken = (): string =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '';
